// Utility for filename normalization to avoid collisions
export function normalizeFilename(existingNames: string[] = [], originalName: string): string {
  const extIndex = originalName.lastIndexOf('.');
  const base = extIndex === -1 ? originalName : originalName.slice(0, extIndex);
  const ext = extIndex === -1 ? '' : originalName.slice(extIndex);

  const nameSet = new Set(existingNames || []);
  if (!nameSet.has(originalName)) return originalName;

  let counter = 1;
  let candidate = '';
  do {
    candidate = `${base} (${counter})${ext}`;
    counter += 1;
  } while (nameSet.has(candidate));

  return candidate;
}

// Rename files that collide with existingNames or with earlier files in the same batch.
export function getFilesWithUniqueNames(files: File[], existingNames: string[] = []): File[] {
  const taken = [...existingNames];
  return files.map((file) => {
    const uniqueName = normalizeFilename(taken, file.name);
    taken.push(uniqueName);
    if (uniqueName === file.name) return file;
    return new File([file], uniqueName, { type: file.type });
  });
}

export default normalizeFilename;
